import { hash, own } from "../util.js";
export const getNip07 = () => window.nostr;
export class Nip07Signer {
    #lock = Promise.resolve();
    #then = async (f) => {
        const promise = this.#lock.then(() => {
            const ext = getNip07();
            if (!ext)
                throw new Error("Nip07 is not enabled");
            return f(ext);
        });
        // Recover from errors
        this.#lock = promise.then(() => undefined, () => undefined);
        return promise;
    };
    getPubkey = async () => this.#then(ext => ext.getPublicKey());
    sign = async (template) => {
        const event = hash(own(template, await this.getPubkey()));
        return this.#then(ext => ext.signEvent(event));
    };
    nip04 = {
        encrypt: (pubkey, message) => this.#then(ext => ext.nip04.encrypt(pubkey, message)),
        decrypt: (pubkey, message) => this.#then(ext => ext.nip04.decrypt(pubkey, message)),
    };
    nip44 = {
        encrypt: (pubkey, message) => this.#then(ext => ext.nip44.encrypt(pubkey, message)),
        decrypt: (pubkey, message) => this.#then(ext => ext.nip44.decrypt(pubkey, message)),
    };
}
//# sourceMappingURL=nip07.js.map